import { render } from "./ReceiversBulkDeleteConfirmationDialog.vue?vue&type=template&id=fb5df638"
import script from "./ReceiversBulkDeleteConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ReceiversBulkDeleteConfirmationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__